/* eslint-disable @typescript-eslint/no-unused-vars */
import { FormGroup } from '@angular/forms';
import { UserPreferences } from '@core/api/data-access';
import { CommunicationPreference } from './user-form.model';
export const UserFormRole = {
	Signer: 'Signer',
	Superuser: 'Superuser',
	User: 'User',
} as const;
export type UserFormRole = (typeof UserFormRole)[keyof typeof UserFormRole];

export const UserFormInitialState = {
	GeneralDetails: {
		username: '' as string,
		fullname: '' as string,
		title: '' as string,
		company: '' as string,
		department: '' as string,
		notes: '' as string,
	},
	ContactInfo: {
		email: '' as string,
		phonenumber: '' as string,
		communicationPreference: 'none' as (typeof CommunicationPreference)[keyof typeof CommunicationPreference],
	},
	Password: {
		password: '' as string,
		confirmPassword: '' as string,
	},
	Permissions: {
		permissions: [UserFormRole.User] as UserFormRole[],
	},
	// More Spacial Sections:
	ActiveUserPreferences: {
		dateFormat: 'DDMMYYYY' as UserPreferences['dateFormat'],
		daysToReminder: 7 as UserPreferences['daysToReminder'],
		penColor: '#000000' as UserPreferences['penColor'],
		penWidth: 2 as UserPreferences['penWidth'],
	},
	ActiveUserStamps: {
		defaultStamp: 1 as UserPreferences['defaultStamp'],
	},
} as const;
export type IUserForm = typeof UserFormInitialState;

export type IUserFormStruct = IUserForm['GeneralDetails'] &
	IUserForm['ContactInfo'] &
	IUserForm['Password'] &
	IUserForm['Permissions'] &
	IUserForm['ActiveUserPreferences'] &
	IUserForm['ActiveUserStamps'];

export type IUserCommunicationPreference = (typeof UserFormInitialState)['ContactInfo']['communicationPreference'];
export const getFormControlSection = (controlName: string): UserFormSection => {
	for (const section of UserFormSections) {
		if (Object.keys(UserFormInitialState[section]).includes(controlName)) {
			return section as UserFormSection;
		}
	}
	return null;
};

export const UserFormControlSections: Record<string, UserFormSection> = Object.entries(UserFormInitialState).reduce(
	(acc, [section, fields]) => {
		Object.keys(fields).forEach(field => {
			acc[field] = section as UserFormSection;
		});
		return acc;
	},
	{} as Record<string, UserFormSection>,
);

export type UserFormSection = keyof IUserForm;
export const UserFormSections = Object.keys(UserFormInitialState) as UserFormSection[];

export type UserFormField<T extends UserFormSection> = IUserForm[T];
export type UserFormSectionFields<T extends UserFormSection> = keyof UserFormField<T>;
export type UserFormSectionFieldsMap = {
	[K in UserFormSection]?: Array<UserFormSectionFields<K>>;
};

export type UserFormSectionValidityFn = (
	section: UserFormSection,
	form: FormGroup,
) => {
	valid: boolean;
	dirty: boolean;
	touched: boolean;
};

export type PasswordRequirement = {
	key: string;
	text: string;
	isValid: boolean;
	check: (password: string) => boolean;
};
